import React from 'react';
import Equities from './Equities';
import { Typography } from 'antd';
import HistoricalPeriod from './HistoricalPeriod';
import AddInstrumentsToRunningSession from './AddInstrumentsToRunningSession';

const { Title } = Typography;

const Commands: React.FC = () => {
  return (
    <div>
      <Title level={3}>Equities</Title>
      <Equities />
      {/*global level historical time has been deprecated in favor of*/}
      {/*the new session-independent historical_time_sleep*/}
      {/*<br />*/}
      {/*<Title level={3}>Historical Period</Title>*/}
      {/*<HistoricalPeriod />*/}
      <br />
      <Title level={3}>Add Instruments to Running Sessions</Title>
      <AddInstrumentsToRunningSession />
    </div>
  );
};
// deploy
export default Commands;
